// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".forum[data-v-0308923e]{border-bottom:1px solid #ddd;overflow:auto;padding:10px;background:#fff;display:block;text-decoration:none}.forum[data-v-0308923e]:hover{background:#f5f5f5}.no-of-posts[data-v-0308923e]{float:right}.latest-post[data-v-0308923e]{padding-top:4px;font-size:14px;color:rgba(50,50,50,.9)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
